import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cta: {
      confirmEmails: `Confirm the invitation emails`,
      sendInvitations: `Send the invitation emails`,
    },
    description:
      'All beneficial owners will receive an email to **complete their personal information** and **send us proof of identity**. This information is **required** to open your pro Shine account',
    emailInputLabel: 'Email address',
    emailsMustBeUniqueError:
      'Each applicant must be associated with a unique, non-shared e-mail address.',
    listHeading: 'An invitation email will be sent to:',
    title: 'Information to be completed by beneficial owners',
  },
  fr: {
    cta: {
      confirmEmails: `Confirmer les e-mails d’invitation`,
      sendInvitations: `Envoyer les e-mails d’invitation`,
    },
    description:
      'Tous les bénéficiaires effectifs vont recevoir un e-mail pour **compléter leurs informations personnelles** et nous **transmettre un justificatif d’identité**. Ces informations sont **obligatoires** pour ouvrir votre compte pro Shine.',
    emailInputLabel: 'Adresse e-mail',
    emailsMustBeUniqueError:
      'Chaque bénéficiaire effectif doit être associé à une adresse e-mail unique, non partagée.',
    listHeading: 'Un e-mail d’invitation va être envoyé à :',
    title: 'Informations à compléter par les bénéficiaires effectifs',
  },
} as const);
